import { StateCreator, create } from 'zustand';
import { PersistOptions, createJSONStorage } from 'zustand/middleware';

import { ProductCategoryKeys } from '../common/enums/common';
import { visionMiddileware } from './middleware';

interface IPersonalizeState {
    gender: string,
    productType: string,
    shape: string,
    type: string,
    material: string,
    color: string,
    price: string,
    brand: string,
    size: string,
    productCategory: ProductCategoryKeys | undefined,
}

interface IPersonalizeActions {
    setGender: (gender: string) => void,
    setProductType: (productType: string) => void,
    setBrand: (brand: string) => void,
    setProductCategory: (category: ProductCategoryKeys) => void,
    setPersonalize: (key: keyof IPersonalizeState, value: any) => void,
    setProductPersonalization: (personalization: Partial<IPersonalizeState>) => void,
}

const InitialState: IPersonalizeState = {
    gender: '',
    productType: '',
    shape: '',
    type: '',
    material: '',
    color: '',
    price: '',
    brand: '',
    size: '',
    productCategory: undefined,
}

const ommitStateProps = ['test']; // ['gender'];

// Saving the states into session 
const personalizeStoreOptions: PersistOptions<IPersonalizeActions & IPersonalizeState, any> = {
    name: 'personalize-store', // unique name for each store created
    storage: createJSONStorage(() => sessionStorage as any),
    onRehydrateStorage: (state) => {
        // optional
        return (state, error) => {
            if (error) {
                console.log('an error happened during hydration', error)
            } else {
                console.log('hydration finished')
            }
        }
    },
    partialize: (state) => {
        // Ommitted state fields can be passed here 
        return Object.fromEntries(
            Object.entries(state).filter(([key]) => !ommitStateProps.includes(key)),
        );
    }
}

const stateCreator: StateCreator<IPersonalizeActions & IPersonalizeState> = (set) => ({
    ...InitialState,
    setGender: (gender) => set((state) => ({ ...state, gender: gender })),
    setProductType: (productType) => set((state) => ({ ...state, productType: productType })),
    setBrand: (brand) => set((state) => ({ ...state, brand: brand })),
    setProductCategory: (category) => set((state) => ({ ...state, productCategory: category })),
    setPersonalize: (objKey, value) => set((state) => {
        // objKey is the state field
        if (typeof value === typeof state[objKey] && value !== state[objKey]) {
            return {
                ...state,
                [objKey]: value
            };
        }
        return state;
    }),
    setProductPersonalization: (personalization) =>  set((state) => {
        return {
            ...state,
            ...personalization
        };
    })
})

export const usePersonalizeStore = create<IPersonalizeActions & IPersonalizeState>()(
    // For Holding the state across the application when refresh is performed
    visionMiddileware(stateCreator, personalizeStoreOptions))